import React from 'react';
import PersonIcon from '@mui/icons-material/Person';
import CloseIcon from '@mui/icons-material/Close';
import DescriptionIcon from '@mui/icons-material/Description';
import GroupIcon from '@mui/icons-material/Group';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { InfoPersonalCliente } from './InfoPersonalCliente';

export function DetalleCliente({ cliente, mostrarModal, onCerrar }) {
    if (!mostrarModal || !cliente) return null;

    const formatearFecha = (fechaString) => {
        const fecha = new Date(fechaString);
        return fecha.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
    };

    const getAtrasoColor = (atraso) => {
        if (atraso > 0) return 'bg-red-50 text-red-700 border-red-200';
        if (atraso < 0) return 'bg-green-50 text-green-700 border-green-200';
        return 'bg-gray-50 text-gray-700 border-gray-200';
    };

    return (
        <div 
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
            onClick={onCerrar}
        >
            <div 
                className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header del Modal */}
                <div className="bg-gradient-to-r from-blue-500 to-indigo-600 px-8 py-6 rounded-t-2xl">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <div className="p-3 bg-white bg-opacity-20 rounded-full">
                                <PersonIcon className="text-white" sx={{ fontSize: 32 }} />
                            </div>
                            <div>
                                <h2 className="text-2xl font-bold text-white">Detalle del Cliente</h2>
                                <p className="text-blue-100 text-sm">Información completa del registro</p>
                            </div>
                        </div>
                        <button
                            onClick={onCerrar}
                            className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
                        >
                            <CloseIcon className="text-white" sx={{ fontSize: 24 }} />
                        </button>
                    </div>
                </div>

                {/* Contenido del Modal */}
                <div className="p-8">
                    {/* Sección: Información Personal */}
                    <InfoPersonalCliente cliente={cliente} />

                    {/* Sección: Información Comercial */}
                    <div className="mb-8">
                        <div className="flex items-center gap-2 mb-4">
                            <div className="p-2 bg-green-100 rounded-lg">
                                <DescriptionIcon className="text-green-600" sx={{ fontSize: 20 }} />
                            </div>
                            <h3 className="text-xl font-bold text-gray-800">Información Comercial</h3>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-xl border border-green-100">
                            <div>
                                <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">Número de Cliente</label>
                                <p className="text-base font-bold text-gray-800">{cliente.numero}</p>
                            </div>
                            <div>
                                <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">Fecha Factura</label>
                                <p className="text-base font-bold text-gray-800">{formatearFecha(cliente.fechaFactura)}</p>
                            </div>
                            <div>
                                <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">Almacén</label>
                                <span className="inline-flex items-center px-3 py-1 rounded-full bg-purple-100 text-purple-700 font-bold text-sm border border-purple-200">
                                    {cliente.almacen}
                                </span>
                            </div>
                            <div>
                                <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">Atraso Promedio</label>
                                <span className={`inline-flex items-center px-4 py-2 rounded-full font-bold text-sm border ${getAtrasoColor(cliente.atrasoPromedio)}`}>
                                    {cliente.atrasoPromedio > 0 ? '+' : ''}{cliente.atrasoPromedio} días
                                </span>
                            </div>
                            <div>
                                <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">Estado de Facturación</label>
                                {cliente.sCre_SolicitudWeb !== null ? (
                                    <div className="flex flex-col gap-1">
                                        <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-100 text-emerald-700 font-bold text-sm border border-emerald-300 w-fit">
                                            <CreditCardIcon sx={{ fontSize: 20 }} />
                                            Facturado
                                        </span>
                                        <p className="text-xs text-gray-600 mt-1">Solicitud: {cliente.sCre_SolicitudWeb}</p>
                                    </div>
                                ) : (
                                    <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gray-100 text-gray-600 font-bold text-sm border border-gray-300 w-fit">
                                        <CloseIcon sx={{ fontSize: 20 }} />
                                        Sin Facturar
                                    </span>
                                )}
                            </div>
                            {/*articulo LVA049 LAVADORA INDURAMA LRI19DGR/AUTOMATICA/19KG/CARGA SUPERIOR/TAMBOR ACERO INOXIDABLE/ANTI-ENREDO*/ }
                            <div className="md:col-span-2">
                                <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">Artículo</label>
                                <p className="text-base font-bold text-gray-800">{cliente.Articulo}</p>
                            </div>
                        </div>
                    </div>

                    {/* Sección: Asignaciones */}
                    <div className="mb-8">
                        <div className="flex items-center gap-2 mb-4">
                            <div className="p-2 bg-purple-100 rounded-lg">
                                <GroupIcon className="text-purple-600" sx={{ fontSize: 20 }} />
                            </div>
                            <h3 className="text-xl font-bold text-gray-800">Asignaciones y Responsables</h3>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-xl border border-purple-100">
                            <div>
                                <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">Vendedor</label>
                                <p className="text-base font-bold text-gray-800">{cliente.vendedor}</p>
                            </div>
                            <div>
                                <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">Bodega Asignada</label>
                                <span className="inline-flex items-center px-3 py-1 rounded-full bg-indigo-100 text-indigo-700 font-bold text-sm border border-indigo-200">
                                    {cliente.bodegaAsignada}
                                </span>
                            </div>
                            <div className="md:col-span-2">
                                <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">Asignado a</label>
                                <span className="inline-flex items-center gap-1 px-4 py-2 rounded-full bg-green-100 text-green-700 font-bold text-sm border border-green-200">
                                    <PersonIcon sx={{ fontSize: 18 }} /> {cliente.asignado}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Botón Cerrar */}
                    <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
                        <button
                            onClick={onCerrar}
                            className="px-6 py-3 bg-gradient-to-r from-gray-500 to-gray-600 text-white font-semibold rounded-xl hover:from-gray-600 hover:to-gray-700 transition-all duration-200 shadow-md hover:shadow-lg"
                        >
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
